import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ProductionLine() {
  const { t } = useTranslation();

  const SectionTitle = ({ children, className = "" }) => (
    <h2 className={`text-[40px] font-bold text-[#E56820] border-b-4 border-[#E56820] w-fit mb-6 ${className}`}>
      {children}
    </h2>
  );

  const MediaFrame = ({ children, className = "" }) => (
    <div className={`relative w-full aspect-video bg-black rounded-2xl shadow-xl overflow-hidden ring-1 ring-black/5 ${className}`}>
      {children}
    </div>
  );

  return (
    <div>
      {/* Header / Landing */}
      <section className="landingPages">
        <div className="container h-full flex items-center justify-between">
          <div className="w-full md:w-[48%] flex flex-col">
            <div className="f-40 text-[50px] font-bold capitalize text-white">
              {t("Production Line")}
            </div>
            <div className="font-bold text-white text-[20px] capitalize flex items-center gap-[7px]">
              <Link to={"/"} className="text-white">{t("Home")}</Link>
              -
              <div className="text-white">{t("Production Line")}</div>
            </div>
          </div>
        </div>
      </section>

      {/* Production line start */}
      <section className="relative py-16 md:py-20 animate-fadeIn">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-10">
            <div>
              <SectionTitle>{t("Production line start")}</SectionTitle>
              <div className="bg-white shadow-lg rounded-lg p-6 text-[18px] leading-relaxed">
                <p>{t("Production line start Description")}</p>
              </div>
            </div>
            <div>
              <img
                src={require("../../assets/product/Crystallizer.JPG")}
                alt={t("product_image")}
                className="w-full h-64 md:h-[360px] object-cover rounded-lg shadow-md"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Crystallizer Furnace - Centered */}
      <section className="relative py-12 md:py-16 animate-fadeIn text-center">
        <div className="container flex flex-col items-center">
          <SectionTitle className="mb-8">{t("Crystallizer Furnace")}</SectionTitle>

          {/* أعرض فيديو أكبر بقليل من النصوص (80-85% من العرض) */}
          <div className="w-full md:w-11/12 lg:w-5/6 xl:w-4/5">
            <MediaFrame>
              <video
                className="absolute inset-0 h-full w-full object-contain"
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
                poster={require("../../assets/company/DSC00010.JPG")}
              >
                <source src="https://alburoujplast.com/CrystallizerFurnace.mp4" type="video/mp4" />
                {t("Your browser does not support HTML5 video.")}
              </video>
            </MediaFrame>
          </div>
        </div>
      </section>

      {/* Extraction Tank - Text Left + Video Right */}
      <section className="relative py-16 md:py-20 animate-fadeIn">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-10">
            <div>
              <SectionTitle>{t("extraction tank")}</SectionTitle>
              <div className="bg-white shadow-lg rounded-lg p-6 text-[18px] leading-relaxed">
                <p>{t("extraction tank Description")}</p>
              </div>
            </div>
            <div>
              <MediaFrame className="md:min-h-[420px]">
                <video
                  className="absolute inset-0 h-full w-full object-contain"
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="metadata"
                  poster={require("../../assets/company/DSC00010.JPG")}
                >
                  <source src="https://alburoujplast.com/step2.mp4" type="video/mp4" />
                  {t("Your browser does not support HTML5 video.")}
                </video>
              </MediaFrame>
            </div>
          </div>
        </div>
      </section>

      {/* Dryer - Text Left + Image Right */}
      <section className="relative py-16 md:py-20 animate-fadeIn">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-10">
            <div>
              <SectionTitle>{t("dryer")}</SectionTitle>
              <div className="bg-white shadow-lg rounded-lg p-6 text-[18px] leading-relaxed">
                <p>{t("dryer Description")}</p>
              </div>
            </div>
            <div>
              <img
                src={require("../../assets/product/dryer.JPG")}
                alt={t("product_image")}
                className="w-full h-64 md:h-[360px] object-cover rounded-lg shadow-md"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Extruder - Text Left + Image Right */}
      <section className="relative py-16 md:py-20 animate-fadeIn">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-10">
            <div>
              <SectionTitle>{t("extruder")}</SectionTitle>
              <div className="bg-white shadow-lg rounded-lg p-6 text-[18px] leading-relaxed">
                <p>{t("extruder Description")}</p>
              </div>
            </div>
            <div>
              <img
                src={require("../../assets/product/extruder.JPG")}
                alt={t("product_image")}
                className="w-full h-64 md:h-[360px] object-cover rounded-lg shadow-md"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Filters - Text Left + Video Right */}
      <section className="relative py-16 md:py-20 animate-fadeIn">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-10">
            <div>
              <SectionTitle>{t("filters")}</SectionTitle>
              <div className="bg-white shadow-lg rounded-lg p-6 text-[18px] leading-relaxed">
                <p>{t("filters Description")}</p>
              </div>
            </div>
            <div>
              <MediaFrame className="md:min-h-[420px]">
                <video
                  className="absolute inset-0 h-full w-full object-contain"
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="metadata"
                  poster={require("../../assets/company/DSC00010.JPG")}
                >
                  <source src="https://alburoujplast.com/filters.mp4" type="video/mp4" />
                  {t("Your browser does not support HTML5 video.")}
                </video>
              </MediaFrame>
            </div>
          </div>
        </div>
      </section>

      {/* Forming plastic - Centered */}
      <section className="relative py-12 md:py-16 animate-fadeIn text-center">
        <div className="container flex flex-col items-center">
          <SectionTitle className="mb-8">{t("forming plastic")}</SectionTitle>
          <div className="w-full md:w-11/12 lg:w-5/6 xl:w-4/5">
            <MediaFrame>
              <video
                className="absolute inset-0 h-full w-full object-contain"
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
                poster={require("../../assets/company/DSC00010.JPG")}
              >
                <source src="https://alburoujplast.com/plastic.mp4" type="video/mp4" />
                {t("Your browser does not support HTML5 video.")}
              </video>
            </MediaFrame>
          </div>
        </div>
      </section>

      {/* Production - Centered */}
      <section className="relative py-12 md:py-16 animate-fadeIn text-center">
        <div className="container flex flex-col items-center">
          <SectionTitle className="mb-8">{t("Production")}</SectionTitle>
          <div className="w-full md:w-11/12 lg:w-5/6 xl:w-4/5">
            <MediaFrame>
              <video
                className="absolute inset-0 h-full w-full object-contain"
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
                poster={require("../../assets/company/DSC00010.JPG")}
              >
                <source src="https://alburoujplast.com/Production.mp4" type="video/mp4" />
                {t("Your browser does not support HTML5 video.")}
              </video>
            </MediaFrame>
          </div>
        </div>
      </section>
    </div>
  );
}
